import { render } from "./CreateVendor.vue?vue&type=template&id=5abcafaa"
import script from "./CreateVendor.vue?vue&type=script&lang=js"
export * from "./CreateVendor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__